import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const NAMES = ['Carlos', 'Miguel', 'Roberto', 'Andrés', 'José', 'Fernando', 'Diego', 'Pablo', 'Alejandro', 'Luis', 'Marcos', 'Javier', 'Ricardo', 'Eduardo', 'Sebastián'];
const CITIES = ['Lima (Perú)', 'Bogotá (Colombia)', 'Ciudad de México (México)', 'Santiago (Chile)', 'Quito (Ecuador)', 'Medellín (Colombia)', 'Guadalajara (México)', 'Buenos Aires (Argentina)', 'São Paulo (Brasil)', 'Montevideo (Uruguay)', 'Caracas (Venezuela)', 'San José (Costa Rica)', 'Panamá (Panamá)', 'Santo Domingo (Rep. Dominicana)', 'La Paz (Bolivia)'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 3000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 10-15 seconds + 5 seconds display time
      const randomDelay = Math.floor(Math.random() * 5000) + 10000;
      setTimeout(showPopup, randomDelay);
    }, 18000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-196">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-3 left-3 md:bottom-6 md:left-6 z-50 bg-amber-50 rounded-xl shadow-2xl p-3 md:p-5 max-w-[280px] md:max-w-sm border-l-8 border-[#f97316] flex items-center gap-3 md:gap-5 border border-amber-200" data-id="element-197">
          <div className="bg-[#f97316] p-2 md:p-3 rounded-full flex-shrink-0 shadow-md" data-id="element-198">
            <ShoppingCart className="w-5 h-5 md:w-6 md:h-6 text-white" data-id="element-199" />
          </div>
          <div data-id="element-200">
            <p className="text-base font-black text-gray-900 leading-tight mb-0.5 md:mb-1" data-id="element-201">
              {currentData.name} de {currentData.city}
            </p>
            <p className="text-sm text-gray-700 font-medium" data-id="element-202">
              acaba de comprar el{' '}
              <span className="font-bold text-[#f97316]" data-id="element-203">
                Mega Pack Acero y Madera
              </span>
            </p>
            <p className="text-xs text-gray-500 mt-1 md:mt-2 font-bold uppercase tracking-wider" data-id="element-204">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}